<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            FEDERALISMO <br>
            Y RECONSTRUCCIÓN <br>
            NACIONAL <br>
            <span style="line-height: 100%;" class="fontMS300">
                (1895-1899) <br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio1/federalismo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio1/federalismo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio1/federalismo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio1/ET01_MS01_FEDE_img001.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    <br>
                    TRAS LAS GUERRAS DE INDEPENDENCIA SURGE LA PREGUNTA, ¿QUÉ FORMA DE GOBIERNO DEBEN TENER LAS NUEVAS
                    NACIONES AMERICANAS? LA GRAN MAYORÍA DE LOS ESTADOS ADOPTAN UN SISTEMA REPUBLICANO Y EL DEBATE SE
                    CENTRA EN SU ORGANIZACIÓN. ¿DEBEN ASUMIR UN SISTEMA FEDERAL COMPUESTO POR ESTADOS SEMIAUTÓNOMOS?, ¿O
                    UN SISTEMA UNITARIO CON UN GOBIERNO CENTRAL? MÉXICO, ARGENTINA, BRASIL Y ESTADOS UNIDOS OPTAN POR EL
                    FEDERALISMO, MIENTRAS PERÚ, CHILE Y BOLIVIA, ENTRE OTROS, SE TORNAN REPÚBLICAS UNITARIAS.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    El debate federalista llega a su punto crítico tras la Guerra del Pacífico (1879-1883). Surgen
                    movimientos federalistas regionales y algunas facciones políticas en la capital. Sin embargo, la
                    declaración del Estado Federal de Loreto en 1896 toma por sorpresa a todo el país. La iniciativa
                    liderada por políticos y militares dura pocos meses. El rechazo generalizado a esta rebelión muestra
                    los miedos de la posguerra, tensiones con los países vecinos por la pérdida de territorio y la
                    posible disolución de todo el país. Las cartas de diversos partícipes o testigos del levantamiento
                    revelan la tensa situación en la Amazonía peruana a finales del siglo XIX; una región apartada del
                    resto del país, escenario de la explotación inhumana de recursos naturales.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            ANTECEDENTES
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40 subtitleSubsec">
                    DEL DEBATE FEDERALISTA
                </p>
                <div class="imgNP">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-justify font-24">
                    <br><br>
                    MIENTRAS JOSÉ DE SAN MARTÍN ABOGABA POR LA MONARQUÍA EN PERÚ, EL LIBERTADOR SIMÓN DE BOLÍVAR
                    IMPULSABA LA CREACIÓN DE UNA CONFEDERACIÓN DE LOS ESTADOS ANDINOS. JOSÉ FAUSTINO SÁNCHEZ CARRIÓN,
                    PRECURSOR E IDEÓLOGO DE LA INDEPENDENCIA, AUTOR DE LA PRIMERA CONSTITUCIÓN PERUANA, DEFIENDE LA
                    CREACIÓN DE UNA REPÚBLICA CON DIVISIÓN DE PODERES Y ORGANIZACIÓN FEDERAL.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    Sánchez Carrión esboza un sistema federal a nivel nacional, es decir, “un gobierno central sostenido
                    por la concurrencia de gobierno locales y sabiamente combinado con ellos”. El periódico <span
                        class="fontMS100Italic">El Federal</span>, en cambio, promueve la propuesta bolivariana de una
                    gran confederación de los Estados de Bolivia, Gran Colombia y Perú, presidida por el mismo
                    libertador. A fin de cuentas, se establece un sistema republicano unitario en Perú, pero el impulso
                    del federalismo no se agotó. El tema reaparecerá con la creación de la Confederación
                    Peruano-Boliviana (1836-1839) y los movimientos regionalistas a fines del siglo XIX.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <p><br></p>
                    </div>
                    <div class="col-sm-4 libro">
                        <a target="_blank" class="enlace"
                            href="http://hdl.handle.net/20.500.14428/79189">
                            <img class="img-fluid mb-3" width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img002a.jpg">
                            <div class="overlayb">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        José Faustino Sánchez Carrión. <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Los Ideólogos,
                                    </span> tomo 1, vol. 9.<br>
                                    Comisión Nacional del Sesquicentenario de la Independencia del Perú, 1974.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/75365"
                            style="color: inherit;" target="_blank">
                            <img class="img-fluid mb-3" width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img002b.jpg">
                            <div class="overlayb">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        <span class="fontMS100Italic">El Federal</span>, no. 2, 1826.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        <br>
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-40 titleSubsec">
                            COLECCIÓN
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40 subtitleSubsec">
                    NICOLÁS DE PIÉROLA
                </p>
                <div class="imgNP">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                </div>
                <br><br><br><br>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            LA BIBLIOTECA NACIONAL DEL PERÚ PRESERVA Y DIFUNDE UNA COLECCIÓN DE ARCHIVOS PRESIDENCIALES.
                            UNO DE LOS MÁS IMPORTANTES ES EL DE NICOLÁS DE PIÉROLA, PRESIDENTE DEL PERÚ EN LOS PERÍODOS
                            1879-1881 Y 1895-1899.
                            <br><br><br>
                        </p>
                        <div class="row">
                            <div class="col-sm-2">
                                <br>
                            </div>
                            <div class="col-sm-10 libro">
                                <a href="https://hdl.handle.net/20.500.14428/55450" target="_blank" style="color: black;">
                                    <img class="img-fluid mb-3 imgNP" width="95%"
                                        src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img003.jpg">
                                    <div class="overlaya">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Nicolás de Piérola.
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                <br>
                                            </span>
                                            Estudio Courret, ca. 1888.
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-24">
                            <br><br><br>
                            La colección contiene más de 17 mil documentos con abundante información sobre la Guerra del
                            Pacífico y la Reconstrucción Nacional. El archivo también documenta las transformaciones
                            sociales, políticas y económicas de este periodo tan agitado de la historia nacional. Sobre
                            la historia militar aparecen temas como el reclutamiento, la adquisición de armamento,
                            campañas, batallas, saqueos, el gobierno provisional y el Ejército del Sur. Tambien brinda
                            información sobre las relaciones internacionales, los intentos de industrialización, la
                            construcción de una red ferroviaria, la migración china y la explotación de recursos en la
                            Amazonía. La sublevación de Iquitos de 1896 tiene una huella significativa en el archivo
                            presidencial, puesto que Piérola se declaró a favor del sistema federal durante su segunda
                            campaña presidencial. Aunque después se distancia de esta postura, la asociación entre
                            Piérola y el federalismo persiste en el imaginario nacional.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
                <br><br>
                <p class="fontMS500 text-justify font-28">
                    ¿CUÁLES FUERON LOS ANTECEDENTES Y LOS DETONANTES INMEDIATOS DE ESTE ACONTECIMIENTO QUE PUDO HABER
                    SACUDIDO LOS CIMIENTOS DEL ORDENAMIENTO POLÍTICO DEL PAÍS? ¿POR QUÉ SI UN AMPLIO SECTOR DEL PAÍS
                    COMPARTÍA EL PLANTEAMIENTO DEL «PRINCIPIO DE NECESIDAD» DEL FEDERALISMO LA CONDENA DE LOS HECHOS FUE
                    TAN CONTUNDENTE? ¿QUÉ SIGNIFICADO TUVO EN EL PAÍS? ¿QUÉ NOS DICE LA PROCLAMACIÓN FEDERAL ACERCA DE
                    LAS LUCHAS ANTICENTRALISTAS DEL SIGLO XIX Y ACERCA DE LA IMAGEN QUE TENÍA EL PAÍS ACERCA DEL ORIENTE
                    AMAZÓNICO?
                    <br>
                </p>
                <p class="fontMS500Italic font-28 text-right">
                    FREDERICA BARCLAY, 2013.
                </p>
                <img id="img_rotate" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 130%;" class="fontMS700 colorAmazonia font-40">
                            LA AMAZONÍA DURANTE LA <br>
                            RECONSTRUCCIÓN
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1a-recortada.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 text-white font-24">
                            <br><br>
                            EL LEVANTAMIENTO DE LORETO OCURRE DURANTE EL "BOOM DEL CAUCHO". POCOS AÑOS DESPUÉS SE SACARÁ
                            A LA LUZ LA BRUTAL OPRESIÓN A LOS PUEBLOS INDÍGENAS PARA EXPLOTAR ESTE RECURSO. ES
                            SIGNIFICATIVO QUE MUCHAS DE LAS CARTAS ESCRITAS POR POLÍTICOS Y DIPLOMÁTICOS DESTINADOS A LA
                            AMAZONÍA DURANTE ESTE PERIODO ALUDEN A LA INCREÍBLE RIQUEZA DE LA REGIÓN SIN MENCIONAR LA
                            EXPLOTACIÓN DE SUS HABITANTES.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-white text-justify font-24 p2">
                            Sin embargo, las cartas de David Arévalo Villacís sí hacen referencia a las tensiones entre
                            las poblaciones indígenas y los políticos y empresarios que buscaron el lucro en la Amazonía
                            a fines del siglo XIX. Sus misivas a Nicolás de Piérola ofrecen detalles sobre la vida
                            cotidiana en su hacienda azucarera. Describe una y otra vez las dificultades que enfrenta
                            para mantener su negocio. Señala la falta de caminos, la innavegabilidad de los ríos, la
                            violencia social en la forma de duelos y asesinatos, la irregularidad de los impuestos y
                            finalmente la corrupción. Los naturales del lugar, las poblaciones indígenas, aparecen en
                            sus cartas como amenaza y, a veces, como mano de obra.

                            <br><br><br>
                        </p>
                    </div>
                </div>
                <!--SCROLL-->
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 text-white font-24 ">
                            Carta de David Arévalo Villacís a Nicolás de Piérola<br>
                            <span class="fontMS100">
                                4 de diciembre de 1896
                            </span>
                        </p>
                        <p class="fontMS100 text-justify text-white font-22  ">
                            En esta carta el ex-prefecto de Loreto elogia la riqueza de la
                            Amazonía y resalta la necesidad de construir caminos.
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-5 libro divAm">
                        <a href="http://hdl.handle.net/20.500.14428/79290" target="_blank" style="color: inherit;">
                            <img width="100%" class="img-fluid mb-3"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img004a.jpg">
                            <div class="overlay3">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        David Arévalo Villacís.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola.
                                        <br>
                                    </span>
                                    4 de diciembre de 1896.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <p>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 text-white font-24  ">
                            Carta de David Arévalo Villacís a Nicolás de Piérola<br>
                            <span class="fontMS100">
                                30 de diciembre de 1896
                            </span>
                        </p>
                        <p class="fontMS100 text-justify text-white font-22  ">
                            En esta carta el ex-prefecto de Loreto describe las dificultades
                            que enfrenta para mantener su hacienda azucarera. <br>

                        </p>
                    </div>
                    <div class="col-sm-5 libro divAm">
                        <a href="http://hdl.handle.net/20.500.14428/79312" target="_blank" style="color: inherit;">
                            <img width="100%" class="img-fluid mb-3 pointer"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img004d.jpg">
                        
                            <div class="overlay3 pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        David Arévalo Villacís.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola.
                                        <br>
                                    </span>
                                    30 de diciembre de 1896
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <p>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 text-white font-24">
                            Carta de David Arévalo Villacís a Nicolás de Piérola<br>
                            <span class="fontMS100">
                                12 de setiembre de 1897
                            </span>
                        </p>
                        <p class="fontMS100 text-justify text-white font-22 ">
                            En esta extensa carta Arévalo relata la muerte del cauchero Carlos
                            Fitzcarraldo. <br>

                        </p>
                    </div>
                    <div class="col-sm-5 libro divAm ">
                        <a href="http://hdl.handle.net/20.500.14428/79310" target="_blank" style="color: inherit;">
                            <img  width="100%" class="img-fluid mb-3 pointer"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img004b.jpg">
                        <div  class="overlay3 pointer">
                            <p class="fontMS100 text-center">
                                <span class="fontMS500">
                                    David Arévalo Villacís.
                                    <br>
                                </span>
                                <span class="fontMS100Italic">
                                    Carta a Nicolás de Piérola.
                                    <br>
                                </span>
                                12 de setiembre de 1897.
                            </p>
                        </div>
                        </a>
                        
                    </div>
                </div>
                <p>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 text-white font-24  ">
                            Carta de David Arévalo Villacís a Nicolás de Piérola<br>
                            <span class="fontMS100">
                                18 de marzo de 1898
                            </span>
                        </p>
                        <p class="fontMS100 text-justify text-white font-22  ">
                            En esta carta Arévalo comenta los disturbios
                            civiles en el departamento de Loreto. <br>
                        </p>
                    </div>
                    <div class="col-sm-5 libro divAm">
                        <a href="https://hdl.handle.net/20.500.14428/76523" target="_blank" style="color: inherit;">
                                <img width="100%" class="img-fluid mb-3 pointer"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img004c.jpg">
                            <div class="overlay3 pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        David Arévalo Villacís.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola.
                                        <br>
                                    </span>
                                    18 de marzo de 1898.
                                </p>
                            </div>
                        </a>
                        
                    </div>
                </div>
                <!--SCROLL-->
                <div class="row">
                    <div class="col-sm-6">
                        <p>
                            <br>
                            <br>
                            <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                        </p>
                    </div>
                    <div class="col-sm-7">

                        <p class="fontMS500 text-white font-24 ">
                            <br>
                            ÁLBUM DE FOTOGRAFÍAS: <br>
                            Viaje de la Comisión Consular al Río Putumayo y Afluentes<br>
                            De agosto a octubre de 1912
                        </p>
                    </div>
                </div>
                <p class="fontMS100 text-justify text-white font-22">
                    A comienzos del siglo XX, la fotografía se convierte en una herramienta importante para exponer
                    las atrocidades de la explotación del caucho en la Amazonía. Después de los primeros reportajes, los
                    caucheros ven en esa misma tecnología una posibilidad de limpiar su imagen. El infame cauchero
                    Julio César Arana contrata al fotógrafo Silvino Santos Silva para preparar un álbum fotográfico. Una
                    de las estrategias empleadas por Arana y Santos Silva es la presentación de elaborados bailes y
                    fiestas típicas. Otra estrategia es el uso de imágenes estereotipadas de “indios salvajes”
                    contrastadas con imágenes que dan cuenta de la supuesta labor civilizadora de la explotación
                    cauchera.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img005a.jpg">
                        <p class="fontMS300Italic font-20 text-white ">
                            Llegada de indios en son de fiesta
                        </p>
                        <br><br><br>
                        <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img005c.jpg">
                        <br>
                        <p class="fontMS300Italic font-20 text-white ">
                            Grupo de huitotos
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="imgAmazonia" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img005b.jpg">
                        <br>
                        <p class="fontMS300Italic font-20 text-white ">
                            Cargando goma
                        </p>
                        <br><br><br>
                        <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img005d.jpg">
                        <br>
                        <p class="fontMS300Italic font-20 text-white ">
                            Huitotas civilizadas
                        </p>
                    </div>
                </div>
                <p>
                    <br>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-5">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS700 colorAmazonia font-40">
                            EL CASO DE LORETO
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1a-recortada2.png">
                    </div>
                </div>
                <br>
                <p class="fontMS500 text-justify font-24 text-white">
                    <br>
                    LOS TESTIMONIOS A CONTINUACIÓN REPRESENTAN DIFERENTES PUNTOS DE VISTA SOBRE LA SUBLEVACIÓN FEDERAL
                    DE LORETO.
                    <br>
                    <span class="fontMS100 text-white font-24">
                        <br>
                        El primero de ellos corresponde a Ricardo Seminario, gobernador del estado federal, quien
                        considera que la propuesta federal corresponde a los postulados del Partido Demócrata de Nicolás
                        de Piérola. Por su parte, el diputado Clemente Alcalá emite un comunicado de última hora
                        mientras viaja en un barco de vapor desde la ciudad más cercana, Pará, Brasil, en el que comenta
                        la huida de los rebeldes y la situación actual en Iquitos. Finalmente, es el cónsul peruano en
                        Brasil, Carlos López Larrañaga, quien asume la administración de Iquitos tras la asonada
                        federalista. Él emite un juicio crítico sobre el conflicto y confirma su resolución pacífica.
                    </span>
                </p>
                <div class="row">
                    <div class="col-sm-3 libro mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/15271" target="_blank">
                                <img class="img_AmBottom img-fluid pointer"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img006a.jpg">
                            <div class="overlay2 pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Ricardo Seminario.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola.
                                        <br>
                                    </span>
                                    6 de mayo de 1896.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/71569" target="_blank">
                                <img class="img_AmBottom img-fluid pointer"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img006b.jpg">
                            <div class="overlay2 pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Pedro Lacalde.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Mariano José Madueño.
                                        <br>
                                    </span>
                                    26 de mayo de 1896.
                                </p>
                            </div>
                        </a>
                        
                    </div>
                    <div class="col-sm-3 libro mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/71571" target="_blank">
                                <img class="img_AmBottom img-fluid pointer"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img006c.jpg">
                            <div class="overlay2 pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clemente Alcalá.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola.
                                        <br>
                                    </span>
                                    17 de julio de 1896.
                                </p>
                            </div>
                        </a>
                        
                    </div>
                    <div class="col-sm-3 libro mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/76530" target="_blank">
                                <img class="img_AmBottom img-fluid pointer"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img006d.jpg">
                            <div class="overlay2 pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Carlos López Larrañaga.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola.
                                        <br>
                                    </span>
                                    5 de octubre de 1896.
                                </p>
                            </div>
                        </a>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco_Rep">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            “Y LA REPÚBLICA ENTERA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    SE PUSO DE PIE CONTRA NOSOTROS”
                </p>
                <div class="imgNP">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                </div>
                <div style="margin-top: 10%;" class="row">
                    <div class="col-sm-6 libro">
                        <a style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79668" target="_blank">
                            <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img007a.jpg">
                            <div class="overlay1">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Mariano José Madueño.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Política peruana: A los pueblos y al Ejército Federal de Loreto.
                                        <br>
                                    </span>
                                    [s.e.], 1896.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            <br>
                            DESDE EL EXILIO MARIANO JOSÉ MADUEÑO EFECTÚA UN BALANCE DEL INTENTO FEDERAL.

                            <br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            Acepta la responsabilidad por los malentendidos o los daños causados, pero se mantiene firme
                            en su opinión de que el federalismo es el mejor sistema para el Perú.
                            Para Madueño, la extensión del territorio, la riqueza material y la diversidad de climas,
                            pueblos y costumbres del Perú ameritan un sistema federal. Su boletín brinda un resumen
                            apasionado de los principales argumentos a favor y en contra del federalismo a fines del
                            siglo XIX.

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris_Img2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 150%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            SECUELAS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    TRES AÑOS MÁS TARDE, UNO DE LOS MILITARES QUE PARTICIPÓ EN LA EXPEDICIÓN PARA SUPRIMIR EL
                    LEVANTAMIENTO DE 1896 LIDERA SU PROPIA REBELIÓN. EN 1899, EL PREFECTO EMILIO VIZCARRA DECLARA LA
                    INDEPENDENCIA DE LA NACIÓN SELVÁTICA.

                </p>
                <br>
                <p class="fontMS100 text-justify font-24">
                    Los mismos políticos que reportaron sobre el primer levantamiento, presagian este acontecimiento en
                    la correspondencia que mantienen con Nicolás de Piérola. Comentan el carácter volátil del prefecto
                    Vizcarra y señalan que falta la presencia del gobierno nacional, puesto que las condiciones sociales
                    y económicas siguen sin resolverse. No obstante, la iniciativa separatista dura poco tiempo, el
                    diputado Clemente Alcalá, documenta el desenlace del levantamiento en sus misivas de última hora.
                    Décadas más tarde el federalismo loretano reaparece en la forma de la Revolución Cervantina de 1921.
                    <br><br><br>
                </p>
                <div style="padding-left: 5%; padding-right: 5%;" class="row">
                    <div class="col-sm-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79311" target="_blank">
                                <img class="img-fluid mb-3 pointer" width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008a.jpg">
                            <div class="overlay pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        David Arévalo Villacís.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola
                                        <br>
                                    </span>
                                    1 de mayo de 1897.
                                </p>
                            </div>
                        </a>
                        
                    </div>
                    <div class="col-sm-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79309"  target="_blank">
                                <img href="http://hdl.handle.net/20.500.14428/79309" class="img-fluid mb-3 pointer" width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008b.jpg">
                            <div href="http://hdl.handle.net/20.500.14428/79309" class="overlay pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Emilio Vizcarra.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola
                                        <br>
                                    </span>
                                    6 de noviembre de 1897.
                                </p>
                            </div>
                        </a>
                        
                    </div>
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/76528" target="_blank">
                                <img href="https://hdl.handle.net/20.500.14428/76528" class="img-fluid mb-3 pointer" width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008c.jpg">
                            <div href="https://hdl.handle.net/20.500.14428/76528" class="overlay pointer">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clemente Alcalá.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Nicolás de Piérola.
                                        <br>
                                    </span>
                                    25 de octubre de 1899.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoCeleste">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Estas cartas, enviadas por políticos y militares, brindan información sobre la relación
                            entre el departamento de Loreto y el gobierno nacional a fines del siglo XIX.
                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            A través de la lectura de estas cartas, te invitamos a analizar la situación y las tensiones
                            de los diversos grupos sociales en Loreto a fines del siglo XIX.

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            La fotografía ha registrado la barbarie de la explotación cauchera. ¿Qué observas en las
                            fotografías?, ¿qué visión de la Amazonía muestran?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Cuál es la situación social, política y ambiental de la Amazonía peruana actualmente?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 font-22">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Barclay, F. (2013).
                            </span><br>
                            El Estado Federal de Loreto, 1896:
                            Centralismo, descentralización y federalismo en el Perú, a fines del siglo XIX.
                            <span class="fontMS100">
                                Lima: IFEA.
                            </span>
                            <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=370816" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Basadre, J. (2005).
                            </span><br>
                            Historia de la República del Perú [1822-1933]. <br>
                            <span class="fontMS100">
                                Tomo 11. Lima: Producciones Cantabria.
                            </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=489573" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Chirif, A. et al. (2014).
                            </span><br>
                            Álbum de fotografías: viaje de la Comisión
                            Consular al río Putumayo y afluentes.
                            <span class="fontMS100">
                                Lima: CAAAP, Tierra Nueva, AECID & IWGIA.
                            </span><br>
                            <a href="https://www.iwgia.org/doclink/caap,-iwgia-libro-a%CC%81lbum-de-fotografi%CC%81as-viaje-de-la-comisio%CC%81n-consular-al-ri%CC%81o-putumayo-y-afluentes-2013-es/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJjYWFwLC1pd2dpYS1saWJyby1hXHUwMzAxbGJ1bS1kZS1mb3RvZ3JhZmlcdTAzMDFhcy12aWFqZS1kZS1sYS1jb21pc2lvXHUwMzAxbi1jb25zdWxhci1hbC1yaVx1MDMwMW8tcHV0dW1heW8teS1hZmx1ZW50ZXMtMjAxMy1lcyIsImlhdCI6MTYxNjE2MTg2MCwiZXhwIjoxNjE2MjQ4MjYwfQ.neC3rRa0GOTWnPGowLDyy6HlpBj4Sn_1zs_wkXU_GjU%22%3Ehttps://www.iwgia.org/doclink/caap,-iwgia-libro-a%CC%81lbum-de-fotografi%CC%81as-viaje-de-la-comisio%CC%81n-consular-al-ri%CC%81o-putumayo-y-afluentes-2013-es/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJjYWFwLC1pd2dpYS1saWJyby1hXHUwMzAxbGJ1bS1kZS1mb3RvZ3JhZmlcdTAzMDFhcy12aWFqZS1kZS1sYS1jb21pc2lvXHUwMzAxbi1jb25zdWxhci1hbC1yaVx1MDMwMW8tcHV0dW1heW8teS1hZmx1ZW50ZXMtMjAxMy1lcyIsImlhdCI6MTYxNjE2MTg2MCwiZXhwIjoxNjE2MjQ4MjYwfQ.neC3rRa0GOTWnPGowLDyy6HlpBj4Sn_1zs_wkXU_GjU"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Espinoza Soriano, W. (2016).
                            </span><br>
                            Loreto, departamento y región
                            San Martín-Ucayali, 1846-2000.
                            <span class="fontMS100">
                                Lima: UNMSM.
                            </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=514314" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                García Jordán, P. (ed.) (1998).
                            </span><br>
                            Fronteras, colonización y mano de obra indígena, Amazonía andina (siglos XIX-XX):
                            la construcción del espacio socio-económico amazónico en Ecuador, Perú y Bolivia
                            (1792-1948).

                            <span class="fontMS100">
                                Lima: PUCP.<br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=242671" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Trillo, G. (2013).
                            </span><br>
                            El archivo Piérola en la Biblioteca Nacional [presentación].
                            <span class="fontMS100">
                                Círculo de Historia Militar del Instituto Riva Agüero - PUCP.<br>
                            </span>
                            <a href="https://www.slideshare.net/ricardo2686/el-archivo-pirola-en-la-biblioteca-nacional"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>